import React from "react";
import { connect } from "react-redux";
import gql from "graphql-tag";
import { getCustomer } from "../config/myqueries";
import * as mutations from "../graphql/mutations";
import withStyles from "@material-ui/core/styles/withStyles";
import tableStyle from "../assets/jss/material-dashboard-react/components/tableStyle.jsx";
import PropTypes from "prop-types";
import GridItem from "../components/Grid/GridItem.jsx";
import GridContainer from "../components/Grid/GridContainer.jsx";
import Card from "../components/Card/Card.jsx";
import CardHeader from "../components/Card/CardHeader.jsx";
import CardBody from "../components/Card/CardBody.jsx";
import {
  Nav,
  NavItem,
  NavLink,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  FormText
} from "reactstrap";
import { spinnerService } from "@chevtek/react-spinners";
import Tab from "../admin/adminDashboard/tab";
import _ from "lodash";
import { Link } from "react-router-dom";
import Button from "../components/CustomButtons/Button.jsx";
import AddIcon from "@material-ui/icons/Add";
import {
  getUserType,
  utilGetCustomer,
  utilGetCustomerExtended
} from "../common/util";
import moment from "moment";
import Select from "react-select";
import { toast } from "react-toastify";

class CustomerDueDashBoard extends React.Component {
  state = {
    inspections: [],
    data: [],
    vehicles: [],
    customers: [],
    customerId: "",
    success: false,
    start: 0,
    end: 10,
    historyForm: false,
    tab_data: "notDue",
    header_tab_data: "dot",
    startDate: "",
    endDate: "",
    dueDate: "",
    vehicleID: "",
    typeName: "",
    selectedOptions: []
  };
  componentDidMount() {
    this.loadCustomerData();
    this.setState({ success: true });
  }

  loadCustomerData = async () => {
    try {
      let { client, user } = this.props;

      spinnerService.show("mySpinner");

      let res = await utilGetCustomerExtended(user, client);
      // 
      this.setState({
        data: res.vehicles.items,
        vehicles: res.vehicles.items,
        customerId: res.id
      });
      const vehArray = new Array();
      if (res.vehicles !== null && res.vehicles.items !== undefined) {
        res.vehicles.items.map(v => {
          let veh = {};
          veh.value = v.id;
          veh.label = v.customerVehicleId;
          vehArray.push(veh);
        });
      }
      // 
      this.setState({
        selectedOptions: vehArray
      });
      spinnerService.hide("mySpinner");
    } catch (err) {
      spinnerService.hide("mySpinner");
      this.setState({ customers: [] });
    }
    /*
    client
      .query({
        query: gql(getCustomer),
        fetchPolicy: `network-only`,
        variables: {
          id: user.username
        }
      })
      .then(data => {
        spinnerService.hide("mySpinner");
        this.setState({
          data: data.data.getCustomer.vehicles.items,
          vehicles: data.data.getCustomer.vehicles.items
        });
      })
      .catch(err => {
        spinnerService.hide("mySpinner");
        this.setState({ customers: [] });
      });
      */
  };
  componentWillReceiveProps(props, preProps) {
    if (props.inspections !== preProps.inspections) {
      let { inspections } = props;
      inspections = inspections.filter(item => {
        return item.vehicle !== null;
      });
      this.setState({ data: inspections, inspections, success: true });
    }
  }
  changePage = i => {
    let start = i * 10 - 10,
      end = i * 10;
    this.setState({ start, end });
  };
  toggleTab = e => {
    let { id } = e.target;
    if (id === "bit" || id === "dot") {
      this.setState({ header_tab_data: id });
    } else this.setState({ tab_data: id });
  };
  tabHeader = () => {
    let { header_tab_data } = this.state;
    return (
      <CardHeader style={{ marginTop: 25 }} color="info">
        <Nav tabs id="header">
          <NavItem>
            <NavLink
              disabled={this.state.historyForm}
              id="dot"
              onClick={this.toggleTab}
              className={header_tab_data === "dot" ? "active" : ""}
            >
              Dot Inspections
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              id="bit"
              disabled={this.state.historyForm}
              className={header_tab_data === "bit" ? "active" : ""}
              onClick={this.toggleTab}
            >
              Bit Inspections
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>
    );
  };

  handleChange = typeName => {
    this.setState({ typeName });
  };

  renderHistoryForm = () => {
    return (
      <Form>
        <h2>
          Enter {this.state.header_tab_data === "dot" ? "DOT" : "BIT"}{" "}
          Inspection History
        </h2>
        <FormGroup>
          <Label for="typeName">Select Vehicle</Label>
          <Select
            required
            value={this.state.typeName}
            id="typeName"
            onChange={this.handleChange}
            placeholder="Select Vehicle"
            options={this.state.selectedOptions}
          />
        </FormGroup>
        <FormGroup>
          <Label for="exampleDate">Inspection Date</Label>
          <Input
            onChange={e =>
              this.setState({
                [e.target.id]: e.target.value
              })
            }
            value={this.state.startDate}
            type="date"
            name="startDate"
            id="startDate"
            placeholder="Inspection Started On dd/mm/yyyy"
          />
        </FormGroup>

        <FormGroup>
          <Label for="exampleDate">Next Due Date</Label>
          <Input
            onChange={e =>
              this.setState({
                [e.target.id]: e.target.value
              })
            }
            value={this.state.dueDate}
            type="date"
            name="dueDate"
            id="dueDate"
            placeholder="Next Inspection Is Due On dd/mm/yyyy"
          />
        </FormGroup>
        <FormGroup>
          <Button onClick={this.cancelForm}> Cancel </Button>
          <Button color="primary" onClick={this.handleSubmit}>
            {" "}
            Submit{" "}
          </Button>
          {/* </FormGroup>
        <FormGroup> */}
        </FormGroup>
      </Form>
    );
  };

  cancelForm = () => {
    this.setState({
      historyForm: false,
      startDate: "",
      endDate: "",
      dueDate: "",
      typeName: ""
    });
  };

  handleSubmit = async () => {
    const { startDate, dueDate, typeName } = this.state;
    if (
      startDate === null ||
      dueDate === null ||
      typeName === null ||
      startDate === undefined ||
      dueDate === undefined ||
      typeName === undefined ||
      startDate === "" ||
      dueDate === "" ||
      typeName === ""
    ) {
      toast.error("Form Incomplete, Please Enter Values");
    } else {
      spinnerService.show("mySpinner");
      let { client, user } = this.props;
      // spinnerService.show("mySpinner");
      // let res = await utilGetCustomer(user, client);
      let startAt = new Date(this.state.startDate).toISOString();
      let endAt = new Date(this.state.startDate).toISOString();
      let nextInspectionDue = new Date(this.state.dueDate)
        .toISOString()
        .split("T")[0];
      let inspType =
        this.state.header_tab_data === "dot"
          ? "DOT_ANNUAL_INSPECTION"
          : "BIT_90DAY_INSPECTION";
      // 
      let input = {
        customerId: this.state.customerId,
        vehicleId: this.state.typeName.value,
        inspectionVehicleId: this.state.typeName.value,
        // inspectorUserType: profile.companyName,
        // priority,
        inspectionType: inspType,
        startAt,
        endAt,
        nextInspectionDue,
        inspectorUserType: "Technicians",
        inspectorUserId: user.username,
        inspectionStatus: "PASSED_NODEFECTFOUND"
      };
      await client.mutate({
        mutation: gql(mutations.createInspection),
        variables: {
          input
        }
      });
      this.setState({
        historyForm: false,
        startDate: "",
        endDate: "",
        dueDate: "",
        typeName: ""
      });
      this.loadCustomerData();
      spinnerService.hide("mySpinner");
    }
  };

  mainDiv = () => {
    let { start, end } = this.state;

    const { classes, user } = this.props;
    let userType = getUserType(user);
    let showNewInspectionBtn = { display: "none" };
    let showNewOTFBtn = { display: "none" };

    let { tab_data } = this.state;
    /*
    if (userType === "Inspectors" || userType === "Technicians")
      showNewInspectionBtn = { display: "inline", float: "right" };
    if (
      userType === "Inspectors" ||
      userType === "Dispatchers" ||
      userType === "Technicians"
    )
      showNewOTFBtn = { display: "inline", float: "right" };
*/
    if (!this.state.success) return <h2>Loading......</h2>;
    else {
      return (
        <React.Fragment>
          <GridContainer>
            <div style={{ float: "right", marginLeft: 15 }}>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                style={showNewInspectionBtn}
                to={{
                  pathname: "/inspection/new/insp"
                }}
                className={classes.blackButton}
              >
                <AddIcon />
                New Inspection
              </Button>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                style={showNewOTFBtn}
                to={{
                  pathname: "/inspection/new/otf",
                  state: { checkOTF: true }
                }}
                className={classes.blackButton}
              >
                <AddIcon />
                New On the Fly Defects
              </Button>
            </div>
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="primary">
                  <h4 className={classes.cardTitleWhite}>Inspection Detail </h4>
                </CardHeader>
                {this.tabHeader()}
                <CardBody style={{ minHeight: 585 }}>
                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        disabled={this.state.historyForm}
                        id="notDue"
                        onClick={this.toggleTab}
                        className={tab_data === "notDue" ? "active" : ""}
                      >
                        Not Due
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        disabled={this.state.historyForm}
                        id="due"
                        className={tab_data === "due" ? "active" : ""}
                        onClick={this.toggleTab}
                      >
                        Due
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        id="history"
                        onClick={this.toggleTab}
                        className={tab_data === "history" ? "active" : ""}
                      >
                        History
                      </NavLink>
                    </NavItem>
                    <div style={{ marginLeft: "60%" }}>
                      {tab_data === "history" && !this.state.historyForm ? (
                        <Button
                          onClick={() =>
                            this.setState({
                              historyForm: !this.state.historyForm
                            })
                          }
                        >
                          {" "}
                          Add History{" "}
                        </Button>
                      ) : (
                        ""
                      )}
                    </div>
                  </Nav>
                  {!this.state.historyForm || tab_data !== "history" ? (
                    <Tab
                      changePage={this.changePage}
                      history={this.props.history}
                      header_tab_data={this.state.header_tab_data}
                      active={tab_data}
                      data={this.state.vehicles}
                      // onDataLoad={this.loadCustomerData}
                      start={start}
                      end={end}
                      classes={classes}
                    />
                  ) : (
                    this.renderHistoryForm()
                  )}
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </React.Fragment>
      );
    }
  };
  render() {
    return <React.Fragment>{this.mainDiv()}</React.Fragment>;
  }
}
CustomerDueDashBoard.defaultProps = {
  tableHeaderColor: "gray"
};

CustomerDueDashBoard.propTypes = {
  classes: PropTypes.object.isRequired,
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};
const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    inspections: state.listInspection.data
  };
};

export default CustomerDueDashBoard = connect(
  mapStateToProps,
  null
)(withStyles(tableStyle)(CustomerDueDashBoard));



// WEBPACK FOOTER //
// ./src/customers/customer-dashboard.jsx